import config from 'constants/config'
import { deepOmmitKeys, mapObject } from 'lib/object/objectUtils'

let sentry
export function initSentryServerSide(Sentry) {
  sentry = Sentry
  sentry.init({
    dsn: process.env.REACT_APP_SENTRY_ID,
    environment: process.env.REACT_APP_SENTRY_ENV,
    release: process.env.HEROKU_SLUG_COMMIT,
  })
}

// Disable global handlers so we don't accidently
// start spamming errors from 3rd party addons
const disabledIntegrations = new Set([
  'GlobalHandlers',
  'TryCatch',
])
export function initSentryClientSide(Sentry) {
  sentry = Sentry
  sentry.init({
    dsn: config.SENTRY_ID,
    environment: config.SENTRY_ENV,
    release: config.commitSha,
    integrations: intergrations => intergrations.filter(i => !disabledIntegrations.has(i.name)),
  })
}

const piiKeys = new Set([
  'first_name',
  'last_name',
  'email',
  'surname',
  'givenname',
  'phone',
  'phone_number',
])
export async function sendErrorToSentry(error, extras = {}) {
  try {
    // We also need to remove any PII from the extras to avoid the whole data being hidden on Sentry
    const obfuscatedExtras = deepOmmitKeys(extras, piiKeys)
    const stringifiedObfuscatedExtras = mapObject(obfuscatedExtras, (extra) => {
      if (typeof extra !== 'object' && !Array.isArray(extra)) return extra
      return JSON.stringify(extra, null, 2)
    })

    sentry.withScope((scope) => {
      scope.setFingerprint(error.message)
      scope.setExtras(stringifiedObfuscatedExtras)

      // Sentry doesn't like capturing a non "Error()" object
      // so if someone throws something that isn't an error, wrap it in an error
      const exception = error instanceof Error ? error : new Error(JSON.stringify(error))
      sentry.captureException(exception)
    })
  } catch (e) {}
}
